import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/routines/$routineId")({
  component: () => <Outlet />,
});
